import { Platform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";
import { IKeyStorage } from "./key-manager";
import { KeyStorageWebService } from "../services/key-storage-web.service";
import { KeyStorageNativeService } from "../services/key-storage-native.service";

export function keyStorageFactory(platform: Platform): IKeyStorage {
  const isNative = Capacitor.isNativePlatform() || platform.is("cordova");
  if (isNative) {
  //  console.log("📱 Using native key storage");
    return new KeyStorageNativeService();
  } else {
  //  console.log("🌐 Using web key storage");
    return new KeyStorageWebService();
  }
}
